/**
 * Component slot
 * @class Slot
 */
export class Slot {
    /**
     * Sets the runner
     * @param func {function} the function to run
     */
    insert(func) {
        this.runner = func;
    }
    /**
     * @param a0 {Fragment} node to paste content
     * @param a1 {*} 1st argument
     * @param a2 {*} 2nd argument
     * @param a3 {*} 3rd argument
     * @param a4 {*} 4th argument
     * @param a5 {*} 5th argument
     * @param a6 {*} 6th argument
     * @param a7 {*} 7th argument
     * @param a8 {*} 8th argument
     * @param a9 {*} 9th argument
     */
    release(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        if (this.runner) {
            this.runner(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
        }
    }
    /**
     * Predefine a handler for a slot
     * @param func {function(node : Fragment)} Function to run if no handler specified
     * @param a0 {Fragment} node to paste content
     * @param a1 {*} 1st argument
     * @param a2 {*} 2nd argument
     * @param a3 {*} 3rd argument
     * @param a4 {*} 4th argument
     * @param a5 {*} 5th argument
     * @param a6 {*} 6th argument
     * @param a7 {*} 7th argument
     * @param a8 {*} 8th argument
     * @param a9 {*} 9th argument
     */
    predefine(func, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        (this.runner || func)(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
    }
}
